import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CookiesPage } from './pages/CookiesPage';
import { RefundsPage } from './pages/RefundsPage';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  const path = window.location.pathname;
  return <>
      <GoogleTagManager data-id="element-0" />
      {path === '/terminos' ? <TermsPage data-id="element-1" /> : path === '/privacidad' ? <PrivacyPage data-id="element-2" /> : path === '/cookies' ? <CookiesPage data-id="element-3" /> : path === '/reembolsos' ? <RefundsPage data-id="element-4" /> : <LandingPage data-id="element-5" />}
    </>;
}